import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable()
export class BaseService {

  apiUrl = environment.apiUrl;

  constructor(protected http: HttpClient) {
  }

  formatDate(date: any) {
    return moment(date).format('YYYY-MM-DD');
  }

  get(uri: string, body: any, flag: boolean = false): Observable<any> {
    body = this.normalBody(body);
    const pars = this.getUrlParams(body);
    return this.http.get((flag ? '' : this.apiUrl) + uri, { params: pars });
  }

  post(uri: string, body: any, options?: any, flag: boolean = false): Observable<any> {
    body = this.normalBody(body);
    return this.http.post((flag ? '' : this.apiUrl ) + uri, body, options);
  }

  delet(uri: string, body: any): Promise<any> {
    body = this.normalBody(body);
    return this.http.delete(this.apiUrl + uri, body).toPromise().then(res => res);
  }

  put(uri: string, body: any): Promise<any> {
    body = this.normalBody(body);
    return this.http.put(this.apiUrl + uri, body).toPromise().then(res => res);
  }

  private normalBody(body: any): any {
    if (!body) {
      body = {};
    }
    for (const key in body) {
      if (!body.hasOwnProperty(key)) {
        continue;
      }
      if (body[key] instanceof Date) {
        body[key] = this.formatDate(body[key]);
      }
    }
    return body;
  }

  private getUrlParams(body: any): HttpParams {
    let params = new HttpParams();
    for (const key in body) {
      if (!body.hasOwnProperty(key)) {
        continue;
      }
      params = params.append(key, body[key]);
    }
    return params;
  }

}
